import { LoadingService } from '../services/loading.service';
import { AppInjector } from '../../app.injector';

export function IsLoading(loadingTag: string): Function {
    return function (target: Record<string, unknown>, propertyKey: string): void {
        const resolvingInstances: WeakSet<object> = new WeakSet<object>();
        Object.defineProperty(target, propertyKey, {
            configurable: true,
            get(this: Record<string, unknown>) {
                if (resolvingInstances.has(this as object)) {
                    return undefined;
                }
                if (Object.prototype.hasOwnProperty.call(this, propertyKey)) {
                    return Object.getOwnPropertyDescriptor(this, propertyKey)?.value;
                }
                resolvingInstances.add(this as object);
                const loadingServiceInstance: LoadingService =
                    AppInjector.get().get(LoadingService);
                const value = loadingServiceInstance?.getIsLoading(loadingTag);
                Object.defineProperty(this, propertyKey, {
                    value,
                    configurable: true,
                });
                resolvingInstances.delete(this as object);
                return value;
            },
        });
    };
}
